export interface AppleMusicLinks {
  app: string;
  web: string;
}

export const buildAppleMusicLinks = (playlistId: string): AppleMusicLinks => {
  const encodedId = encodeURIComponent(playlistId);
  const baseUrl = `https://music.apple.com/library/playlist/${encodedId}`;

  return {
    app: `${baseUrl}?app=music`,
    web: baseUrl,
  };
};
